export default "__VITE_ASSET__avIdI1eL__"